function NoIndexGraph() {
  return (
    <div className="sm:pb-16 pb-4">
      <div className="flex  flex-col sm:col-span-3 border-0 shadow">
        <div className="flex flex-col border-b border-solid border-gray-200 container mx-auto p-6">
          <div className="flex flex-col">
            <div className="flex flex-col sm:flex-row sm:justify-between">
              <h1 className="font-medium text-lg text-gray-900 pb-4 sm:pb-0">
                Historical Index Chart
              </h1>
              <div className="flex flex-row pb-5">
                <button
                  disabled
                  className="border border-solid border-gray-200 rounded-lg shadow-sm h-10"
                >
                  <span className="px-4 font-medium text-sm text-gray-300">
                    Choose custom dates
                  </span>
                </button>
                <div className="pl-3">
                  <button
                    disabled
                    className="border border-solid border-primary-25 bg-primary-25 rounded-lg shadow-sm h-10"
                  >
                    <span className="px-4 font-medium text-sm text-primary-300">
                      Detailed index view
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col container mx-auto py-10">
            <div className="flex justify-center items-center">
              <div className="w-full max-w-xl rounded-lg bg-gray-800/50 px-6 py-5 text-center">
                <p className="font-semibold text-base text-white">
                  We&rsquo;re collecting data to craft your index history.
                </p>
                <p className="italic font-normal text-sm text-gray-200 mt-1">
                  Usually this chart becomes available in 24 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoIndexGraph
